/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-07-31 14:20:22
 * @LastEditTime: 2021-06-18 11:08:35
 * @Description: 用户store
 */
import {
  login,
  resetMyPassword,
  logout,
  getMyInfo
} from '@/api/auth'

const state = {
  currentUser: {
    _id: undefined,
    name: undefined,
    mobile: undefined,
    simpleRole: [],
    superAdmin: undefined,
    initial: undefined
  }
}

const actions = {
  async loginAction({
    commit
  }, payload) {
    try {
      const {
        data: user
      } = await login(payload);
      const data = {
        _id: user._id,
        name: user.name,
        mobile: user.mobile,
        simpleRole: user.simpleRole,
        superAdmin: user.superAdmin,
        initial: user.initial
      }
      localStorage.setItem('token', user.token)
      commit('SET_CURRENT_USER', data)
      return user.data
    } catch (error) {
      throw error.message
    }
  },
  async logoutAction({
    commit
  }) {
    try {
      await logout()
    } catch (error) {
      throw error.message
    }
    localStorage.removeItem("token")
  },
  async resetMyPasswordAction({
    commit
  }, {
    password,
    oldPassword
  }) {
    try {
      const res = await resetMyPassword({
        password,
        oldPassword
      });
      localStorage.setItem('token', res.data.token)
    } catch (error) {
      throw error.message
    }
  },
  async getMyInfoAction({
    commit
  }) {
    try {
      const {
        data
      } = await getMyInfo();
      commit('SET_CURRENT_USER', data)
      return data;
    } catch (error) {
      throw error.message
    }
  },
}

const mutations = {
  SET_CURRENT_USER(state, payload) {
    state.currentUser = payload
  },
  RESET(state) {
    state.currentUser = {
      _id: undefined,
      name: undefined,
      mobile: undefined
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}